import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=69d46f5c&scoped=true"
import script from "./Accident.vue?vue&type=script&lang=js"
export * from "./Accident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d46f5c",
  null
  
)

export default component.exports